import { render, staticRenderFns } from "./WorkorderSiteHistory.vue?vue&type=template&id=4bde1477"
import script from "./WorkorderSiteHistory.vue?vue&type=script&lang=js"
export * from "./WorkorderSiteHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports